(function () {
  const originalFetch = window.fetch;
  const addToCartBtn = document.querySelector('.buy-buttons button[type="submit"]');

  let previousFilterParams = '';

  // Check if filter parameters in the URL have changed since the last check
  function hasFilterParamsChanged(currentParams) {
      const filterParams = [];

      currentParams.forEach((value, key) => {
          if (key.startsWith('filter.')) {
              filterParams.push({ key, value });
          }
      });

      const currentFilterParamsString = JSON.stringify(filterParams);
      if (currentFilterParamsString !== previousFilterParams) {
          previousFilterParams = currentFilterParamsString;
          return true;
      }
      return false;
  }

  // Override the global fetch function to hook into cart/filter updates
  window.fetch = async (...args) => {
      const response = await originalFetch(...args);

      const isCartRequest = args[0].includes('/cart/change') || args[0].includes('/cart/update');

      const urlParams = new URLSearchParams(window.location.search);

      // Event: Announce product list update if filter parameters have changed
      if (hasFilterParamsChanged(urlParams)) {
          setGlobalStatus(window.translations.accessibility_product_updated);
      }

      // Event: Announce cart state change after update or change action
      if (isCartRequest) {
          try {
              const data = await response.clone().json();
              const message =
                  data.items && data.items.length > 0
                      ? window.translations.accessibility_cart_updated
                      : window.translations.accessibility_cart_empty;

              setGlobalStatus(message);
          } catch (err) {
              console.warn('Cart data could not be read.', err);
          }
      }

      return response;
  };

  // Event: Announce that product was added to cart (after add-to-cart button click)
  if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function () {
          setTimeout(() => {
              setGlobalStatus(window.translations.accessibility_cart_add);
          }, 300);
      });
  }

  // Set accessible status message (read by screen reader)
  function setGlobalStatus(message) {
      const el = document.getElementById('global-status-message');
      if (el) {
          el.textContent = ''; // Clear to ensure screen reader re-announces
          setTimeout(() => {
              el.textContent = message;
          }, 10);
      }
  }
})();
